// for now if channel is not found, server returns internal error
export enum GetMemberCountErrors {
  Internal = 100,
  PrivateChannel = 51,
}

export const GetMemberCountErrorMessages = {
  [GetMemberCountErrors.Internal]: "InternalError",
  [GetMemberCountErrors.PrivateChannel]: "کانال انتخابی شما خصوصی است.",
};
